"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TapSchema = exports.TapInitialized = void 0;
const joi_1 = __importDefault(require("joi"));
const joiMessages_1 = require("../data/joiMessages");
exports.TapInitialized = {
    tapNumber: 1,
    tapName: '',
    description: '',
    location: '',
    waitTime: 4,
    keg: '',
    drink: null,
    GPIO: '',
    isActive: false,
    useTorioWebUrl: false,
    callbackSelectURL: '',
    callbackFinishURL: '',
    fixedMarginBottom: 0,
    fixedMarginTop: 0,
    tabletCode: 0,
    requireStaff: false,
    useKegs: false,
    isPurchaseMode: false,
    hideRating: false,
    onlyAllowCredit: false,
    minutesUntilAgeCheck: 0,
    maxGlassesToAllow: 0,
    allowGlassMl: 0,
    glassMl: 0,
    ignoreEmptyKeg: false,
    isFree: false,
    allowPaperQR: true,
    device: {},
    ageLimit: 20,
    useAgeLimit: false,
    iceCertRequired: false,
    allowTabletQR: false,
    showCloseButton: false,
    showTermsText: false,
    showLogout: false,
    hideMl: true,
    isTest: false,
    isPOSMode: false,
    payOrder: 'PayBefore',
    paymentType: 'Credit',
    flowType: 'ContinuousFlow',
};
exports.TapSchema = joi_1.default.object({
    tapNumber: joi_1.default.number(),
    tapName: joi_1.default.string()
        .optional()
        .allow('')
        .max(70)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({
            name: 'Tap number',
            patternText: 'cannot be this long.',
        }),
    }),
    description: joi_1.default.string()
        .optional()
        .allow('')
        .max(70)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({
            name: 'Description',
            patternText: 'cannot be this long.',
        }),
    }),
    location: joi_1.default.string()
        .optional()
        .allow('')
        .max(70)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({
            name: 'Location',
            patternText: 'cannot be this long.',
        }),
    }),
    flowType: joi_1.default.string().optional().allow(''),
    waitTime: joi_1.default.number(),
    hideRating: joi_1.default.boolean(),
    ageLimit: joi_1.default.number(),
    iceCertRequired: joi_1.default.boolean(),
    drink: joi_1.default.any(),
    keg: joi_1.default.any(),
    GPIO: joi_1.default.any(),
    minutesUntilAgeCheck: joi_1.default.number(),
    glassMl: joi_1.default.number(),
    allowGlassMl: joi_1.default.number(),
    maxGlassesToAllow: joi_1.default.number(),
    tabletCode: joi_1.default.number(),
    showTermsText: joi_1.default.boolean(),
    isActive: joi_1.default.boolean(),
    isFree: joi_1.default.boolean(),
    isPurchaseMode: joi_1.default.boolean(),
    requireStaff: joi_1.default.boolean(),
    allowPaperQR: joi_1.default.boolean(),
    isPOSMode: joi_1.default.boolean(),
    device: joi_1.default.any(),
    useTorioWebUrl: joi_1.default.boolean(),
    allowTabletQR: joi_1.default.boolean(),
    onlyAllowCredit: joi_1.default.boolean(),
    showCloseButton: joi_1.default.boolean(),
    ignoreEmptyKeg: joi_1.default.boolean(),
    callbackSelectURL: joi_1.default.string().optional().allow(''),
    callbackFinishURL: joi_1.default.string().optional().allow(''),
    useAgeLimit: joi_1.default.boolean(),
    fixedMarginBottom: joi_1.default.number(),
    fixedMarginTop: joi_1.default.number(),
    hideMl: joi_1.default.boolean(),
    showLogout: joi_1.default.boolean(),
    isTest: joi_1.default.boolean(),
    useKegs: joi_1.default.boolean(),
    payOrder: joi_1.default.string()
        .optional()
        .allow('')
        .valid(...['PayAfter', 'PayBefore', ''])
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({
            name: 'Pay order',
            patternText: 'cannot have this value.',
        }),
    }),
    paymentType: joi_1.default.string()
        .optional()
        .allow('')
        .valid(...['Payment', 'Credit', ''])
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({
            name: 'Payment type',
            patternText: 'cannot have this value.',
        }),
    }),
});
// export const userFromBackend = (data) => {
// 	return {
// 		places: data.places,
// 		placeUser: data.placeUser,
// 		email: data.email,
// 		phone: data.phone,
// 		allowPhoneLogin: data.allowPhoneLogin,
// 		country: data.country,
// 		countryPhoneCode: data.countryPhoneCode,
// 		phoneConfirmed: data.phoneConfirmed,
// 		firstName: data.firstName,
// 		lastName: data.lastName
// 	};
// };
// export const setUserInitalized = (data) => {
// 	return {
// 		phone: data.phone,
// 		allowPhoneLogin: data.allowPhoneLogin,
// 		country: data.country,
// 		countryPhoneCode: data.countryPhoneCode,
// 		firstName: data.firstName,
// 		lastName: data.lastName,
// 	};
// };
// export const setAllUserInitalized = (data) => {
// 	return data;
// };
// export const setPhoneInitalized = (data) => {
// 	return {
// 		phone: data.phone,
// 		countryPhoneCode: data.countryPhoneCode,
// 		phoneConfirmed: data.phoneConfirmed,
// 	};
// };
